module.exports = __webpack_public_path__ + "img/20170704_135648_086.faeac41c.jpg";